"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordUpdateSchema = exports.PasswordSchema = void 0;
var zod_1 = require("zod");
exports.PasswordSchema = zod_1.z
    .string({ required_error: 'Password must be at least 6 characters long' })
    .min(6, 'Password must be at least 6 characters long')
    .refine(function (value) { return /[A-Z]/.test(value); }, { message: 'Password must contain at least one uppercase letter' })
    .refine(function (value) { return /[a-z]/.test(value); }, { message: 'Password must contain at least one lowercase letter' })
    .refine(function (value) { return /[0-9]/.test(value); }, { message: 'Password must contain at least one number' })
    .refine(function (value) { return /[\W_]/.test(value); }, { message: 'Password must contain at least one special character' });
exports.PasswordUpdateSchema = zod_1.z
    .object({
    password: exports.PasswordSchema,
    confirmPassword: zod_1.z
        .string({ required_error: 'Confirm password must be at least 6 characters long' })
        .min(6, 'Confirm password must be at least 6 characters long'),
})
    .refine(function (data) { return data.password === data.confirmPassword; }, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});
//# sourceMappingURL=Password.js.map